import request from '@/utils/request2'

// 列表(主数据列表)
export function loadStoreInfoListDataApi(data) {
  return request({
    url: 'tms-web/storeInfo/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportStoreInfoListDataApi(data) {
  return request({
    url: 'tms-web/storeInfo/exportByPage',
    method: 'post',
    data
  })
}

// 派工列表(主数据列表)
export function loadDispatchStoreInfoListDataApi(data) {
  return request({
    url: 'tms-web/storeInfo/listForDispatchByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveStoreInfoApi(data) {
  return request({
    url: 'tms-web/storeInfo/save',
    method: 'post',
    data
  })
}

// 保存拜访计划
export function saveStoreVisitPlanApi(data) {
  return request({
    url: 'tms-web/storeInfo/savePlan',
    method: 'post',
    data
  })
}

// 更新状态
export function updateStoreInfoStatusApi(data) {
  return request({
    url: 'tms-web/storeInfo/updateStatus',
    method: 'post',
    data
  })
}

// 更新状态
export function updateStoreInfoStopStatusApi(data) {
  return request({
    url: 'tms-web/storeInfo/updateStatusStop',
    method: 'post',
    data
  })
}

// 作废
export function deleteStoreInfoApi(data) {
  return request({
    url: 'tms-web/storeInfo/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewStoreInfoApi(data) {
  return request({
    url: 'tms-web/storeInfo/view',
    method: 'post',
    data
  })
}

// 列表
export function listStoreInfoApi(data) {
  return request({
    url: 'tms-web/storeInfo/list',
    method: 'post',
    data
  })
}

// 零售户高价值记录
export function listStoreHighValueApi(data) {
  return request({
    url: 'tms-web/storeInfo/listStoreHighValue',
    method: 'post',
    data
  })
}

// 零售户变更记录
export function listStoreChangeInfoApi(data) {
  return request({
    url: 'tms-web/storeInfo/listStoreChangeInfo',
    method: 'post',
    data
  })
}

// 零售户代办
export function countTodoStoreInfoApi(data) {
  return request({
    url: 'tms-web/storeInfo/countTodo',
    method: 'post',
    data
  })
}
